import { resolveAssetUrl } from "../../services/apiConfig";
import { Link } from "react-router-dom";
import styles from "./FollowModal.module.css";
import { useEffect } from "react";
import { useFollow } from "../../hooks/useFollow";

function FollowModal({ isVisible, handleModal, users, heading }) {
  const { followState, setFollowState, handleFollow } = useFollow();
  useEffect(() => {
    const initialFollowState = {};

    users.forEach((user) => {
      // Add to followState for followers
      if (user?.follower?.id) {
        initialFollowState[user.follower.id] = false;
      }

      // Add to followState for following
      if (user?.following?.id) {
        initialFollowState[user.following.id] = true;
      }

      // Add to followState for suggestions
      if (user?.id) {
        initialFollowState[user.id] = false;
      }
    });

    setFollowState(initialFollowState);
  }, [users, setFollowState]);

  const closeModal = () => {
    handleModal(false);
  };

  const handleFollowClick = (userId, isRemoved) => {
    handleFollow(userId, isRemoved);
  };



  if (!isVisible) return null;

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modalContent}>
        <h1>{heading}</h1>
        {users.map((user, index) => {
          const user_name =
            user?.username ||
            user?.user?.username ||
            user?.follower?.username ||
            user?.following?.username ||
            "Usuário desconhecido";

          const isFollower = user?.follower?.username;
          const isFollowing = user?.following?.username;
          const isSuggestionToFollow = user?.username;

          const userIdToToggle = isFollower
            ? user?.follower?.id
            : isFollowing
            ? user?.following?.id
            : isSuggestionToFollow
            ? user?.id
            : null;

          return (
            <div className={styles.suggestedAccount} key={userIdToToggle || index}>
              <div className={styles.accountDetails}>
                <div className={styles.accountImage}>
                  <img
                    src={
                      resolveAssetUrl(user.profile_url || user.user?.profile_url, resolveAssetUrl("images/profile_image/user.png"))
                    }
                    alt="Conta sugerida"
                  />
                </div>
                <Link to={`/profile/${user_name}`}>
                  <p>{user_name}</p>
                </Link>
              </div>

              {isFollower && userIdToToggle && (
                <button
                  onClick={() => handleFollowClick(userIdToToggle, true)}
                  className={followState[userIdToToggle] ? styles.unfollow : ""}
                >
                  {followState[userIdToToggle] ? "Seguir" : "Remover"}
                </button>
              )}

              {isFollowing && userIdToToggle && (
                <button
                  onClick={() => handleFollowClick(userIdToToggle)}
                  className={followState[userIdToToggle] ? styles.unfollow : ""}
                >
                  {followState[userIdToToggle] ? "Deixar de seguir" : "Seguir"}
                </button>
              )}

              {isSuggestionToFollow && userIdToToggle && (
                <button
                  onClick={() => handleFollowClick(userIdToToggle)}
                  className={followState[userIdToToggle] ? styles.unfollow : ""}
                >
                  {followState[userIdToToggle] ? "Deixar de seguir" : "Seguir"}
                </button>
              )}
            </div>
          );
        })}
        {/* Close button */}
        <button className={styles.closeButton} onClick={closeModal}>
          Fechar
        </button>
      </div>
    </div>
  );
}

export { FollowModal };
